import NativeApplicationImg from "@assets/images/cross-platform-application-compatible-on-different-devices.avif";

export const data = {

    heading: "Why Choose Cross\u2011Platform Mobile Development?",


    list: [
        { boldText: 'Accelerated Time-to-Market', text: 'Reach users on both major platforms up to 50% faster than traditional dual-native development tracks.' },
        { boldText: '30–70% Cost Savings', text: 'Drastically reduce initial build and long-term maintenance expenses by utilizing a single codebase for iOS and Android.' },
        { boldText: 'Enterprise-Grade Reliability', text: 'Benefit from mature, expert-backed frameworks like Flutter (Google) and React Native (Meta).' },
        { boldText: 'Unified UI/UX', text: 'Ensure brand consistency across all devices with a single design language that still respects platform-specific user behaviors.' },
        { boldText: 'Hot Reloads', text: ' Leverage rapid iteration tools to push updates and fix bugs in real-time during the development cycle.' },
        
    ]
    ,
    img: NativeApplicationImg,
    altText: 'A food-ordering mobile app being viewed simultaneously on an iPhone and android mobile phone.'

}